import ApiInfo from './ApiInfo.js';

class QukanApiInfo extends ApiInfo {
    // 声明接口类
    constructor ({ path, type = 'get', timeout = 5000, headers, project = 'qukan', author = '未定义' }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        });
    }
}

export default {
    config: {
        list: new QukanApiInfo({
            path: '/admin/config/getConfigList',
            type: 'get',
            author: '刘彪'
        }),
        modify: new QukanApiInfo({
            path: '/admin/config/modify',
            type: 'post',
            author: '刘彪'
        }),
        getConfigLog: new QukanApiInfo({
            path: '/admin/config/getConfigLog',
            type: 'get',
            author: '刘彪'
        })
    },
    version: {
        modify: new QukanApiInfo({
            path: '/admin/appversion/modify',
            type: 'post',
            author: '刘彪'
        }),
        add: new QukanApiInfo({
            path: '/admin/appversion/add',
            type: 'post',
            author: '刘彪'
        })
    },
    package: {
        modify: new QukanApiInfo({
            path: '/admin/appversion/modify',
            type: 'post',
            author: '刘彪'
        }),
        add: new QukanApiInfo({
            path: '/admin/appversion/add',
            type: 'post',
            author: '刘彪'
        })
    },
    domain: {
        getList: new QukanApiInfo({
            path: '/admin/domain/index',
            type: 'get',
            author: '刘彪'
        }),
        delete: new QukanApiInfo({
            path: '/admin/domain/deleteDomain',
            type: 'post',
            author: '刘彪'
        }),
        modify: new QukanApiInfo({
            path: '/admin/domain/modifyDomain',
            type: 'post',
            author: '刘彪'
        }),
        add: new QukanApiInfo({
            path: '/admin/domain/addDomain',
            type: 'post',
            author: '刘彪'
        }),
        domainImport: new QukanApiInfo({
            path: '/admin/domain/domainImport',
            type: 'post',
            author: '刘彪'
        })
    },
    push: {
        list: new QukanApiInfo({
            path: '/admin/push/getPushLogList',
            type: 'post'
        })
    },
    content: {},
    sensitiveword: {
        list: new QukanApiInfo({
            path: '/admin/sensitiveword/index',
            type: 'get',
            author: '郭选锋'
        })
    },
    complaint: {
        list: new QukanApiInfo({
            path: '/admin/complaint/listMember',
            type: 'get',
            author: '刘彪'
        })
    },
    upload: {},
    contentTop: {
        del: new QukanApiInfo({
            path: '/admin/contenttop/del',
            type: 'post',
            author: '罗磊'
        }),
        enable: new QukanApiInfo({
            path: '/admin/contenttop/enable',
            type: 'post',
            author: '罗磊'
        }),
        getList: new QukanApiInfo({
            path: '/admin/contenttop/getList',
            type: 'post',
            author: '罗磊'
        })
    },
    comment: {
        index: new QukanApiInfo({
            path: '/admin/comment/index',
            type: 'get',
            author: '刘彪'
        })
    },
    collect: {},
    contentclassification: {},
    commentAudit: {},
    image: {},
    pushContent: {},
    member: {},
    cheat: {},
    convert: {},
    exchange: {},
    message: {},
    cdn: {},
    audit: {},
    permission: {},
    contentAudit: {},
    video: {},
    contentReview: {},
    announcement: {},
    auditLog: {},
    adminMember: {}
};
